type GAEventName =
  | "signin_event"
  | "signup_start_event"
  | "signup_completed_event"
  | "admin_paid_event"
  | "admin_signup_paid_event";

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
export const trackGaEvent = (eventName: GAEventName) => {
  window.dataLayer = window.dataLayer ?? [];

  window.dataLayer.push({
    event: eventName,
  });
};
